import axios from '@/config/axios'

const checkListTemplateBase = "/v1/api/mg/checkListTemplate"

export const checkListType = (query) => axios.get(`${checkListTemplateBase}`, {params: query})

export const addCheckList = (checkList) => axios.post(`${checkListTemplateBase}`, checkList)

export const updateCheckList = (checkListType) => axios.put(`${checkListTemplateBase}/${checkListType.id}`, checkListType)


export const deleteCheckList = (id) => axios.delete(`${checkListTemplateBase}/${id}`)
